import { render, staticRenderFns } from "./secret.vue?vue&type=template&id=4546b212&scoped=true&"
import script from "./secret.vue?vue&type=script&lang=js&"
export * from "./secret.vue?vue&type=script&lang=js&"
import style0 from "./secret.vue?vue&type=style&index=0&id=4546b212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546b212",
  null
  
)

export default component.exports